import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {Button, CircularProgress, Stack} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import {
  canDeregisterBusinessProfile,
  canRegisterBusinessProfile,
} from '../../../constants/businessProfileStatusConstants.jsx';
import { useRegisterBusinessProfileHandler } from '../dataHandlers/registerBusinessProfileHandler';
import { useDeregisterBusinessProfileHandler } from '../dataHandlers/deregisterBusinessProfileHandler';
import BusinessProfileDeregisterDialog from './BusinessProfileDeregisterDialog';
import {useSelector} from "react-redux";

const BusinessDetailsPageActionButtons = ({ businessProfile }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const isRootUser = useSelector(state =>  state?.user?.user?.is_root_user)
  const [deregisterDialogOpen, setDeregisterDialogOpen] = useState(false);

  const profileId = businessProfile?.profile_id;
  const { registerBusinessProfile, isPending: isRegisterPending } = useRegisterBusinessProfileHandler();
  const { deregisterBusinessProfile, isPending: isDeregisterPending } = useDeregisterBusinessProfileHandler({
    onSuccess: () => setDeregisterDialogOpen(false),
  });

  const showRegister = canRegisterBusinessProfile(businessProfile) && isRootUser;
  const showDeregister = canDeregisterBusinessProfile(businessProfile) && isRootUser;
  const peppolIdentifier = `${businessProfile?.endpoint_scheme_id || '0248'}:${businessProfile?.endpoint_id || ''}`;

  const onClickingBackButton = () => {
    navigate('/business-profiles');
  };

  const onClickingRegister = () => {
    registerBusinessProfile(profileId);
  };

  const onClickingDeregister = () => {
    setDeregisterDialogOpen(true);
  };

  const onConfirmDeregister = () => {
    deregisterBusinessProfile(profileId);
  };

  return (
    <>
      <Stack direction="row" spacing={1}>
      {showRegister && (
        <Button
          id="business-profile-register"
          variant="contained"
          color="primary"
          onClick={onClickingRegister}
          disabled={isRegisterPending}
          className="action-button"
          startIcon={isRegisterPending ? <CircularProgress size={16} color="inherit" /> : null}
        >
          {isRegisterPending ? 'Registering...' : 'Register'}
        </Button>
      )}
      {showDeregister && (
        <Button
          id="business-profile-deregister"
          variant="outlined"
          color="error"
          onClick={onClickingDeregister}
          disabled={isDeregisterPending}
          className="action-button"
          sx={{ marginLeft: theme.spacing(1) }}
        >
          Deregister
        </Button>
      )}
      <Button
        id="business-profile-back"
        key="back"
        variant="contained"
        color="primary"
        onClick={onClickingBackButton}
        className="action-button"
        sx={{ marginLeft: theme.spacing(1) }}
      >
        Back
      </Button>
      </Stack>

      <BusinessProfileDeregisterDialog
        open={deregisterDialogOpen}
        onClose={() => setDeregisterDialogOpen(false)}
        onConfirm={onConfirmDeregister}
        peppolIdentifier={peppolIdentifier}
        isPending={isDeregisterPending}
      />
    </>
  );
};

export default BusinessDetailsPageActionButtons;
